import { ErrorType } from "@/app/types";
import { Label } from "@/components/ui/Label";
import { Separator } from "@/components/ui/Separator";
import {
  Sheet,
  SheetContent,
  SheetDescription,
  SheetHeader,
  SheetTitle,
} from "@/components/ui/Sheet";
import { useToast } from "@/components/ui/UseToast";
import { useEffect, useState } from "react";
import { useUpdateCounterMutation } from "@/services/CounterApi";
import { CounterDetails } from "@/app/types/counter";
import { Status } from "@/app/shared_enums/enums";

interface AssignCounterForm {
  isOpen: boolean;
  setOpen: React.Dispatch<React.SetStateAction<boolean>>;
  refetch?: any;
  setData?: any;
  data: CounterDetails | undefined;
}

const AssignCounter = ({
  isOpen,
  setOpen,
  refetch,
  data,
  setData,
}: AssignCounterForm) => {
  const { toast } = useToast();
  const [staffs, setStaffs] = useState<any[]>([]);
  useEffect(() => {
    if (data) {
      setStaffs(data.staff_members);
    }
  }, [data, setData]);

  const [updateCounter] = useUpdateCounterMutation();
  const unassignStaff = async (id: string) => {
    const newStaffList = staffs
      .filter((user) => user.id != id)
      .map((user) => user.id);

    const payload = {
      counterId: data?.id as number,
      status: data?.status as Status,
      staff_ids: newStaffList,
      code: data?.code as string,
    };

    try {
      const resp = await updateCounter(payload).unwrap();
      if (resp) {
        refetch();
        toast({
          variant: "success",
          title: "Counter Updated Successfully",
        });
      }
      setOpen(false);
    } catch (error) {
      console.error("Error", { error });
      if (error && typeof error === "object" && "data" in error) {
        const typedError = error as ErrorType;
        toast({
          variant: "destructive",
          title: "Error in form Submission",
          description: `${typedError.data?.detail ?? typedError.data?.message}`,
        });
      } else {
        toast({
          variant: "destructive",
          title: "Error in form Submission",
          description: `Something Went Wrong.`,
        });
      }
    }
  };

  return (
    <div>
      <Sheet open={isOpen} onOpenChange={setOpen}>
        <SheetContent>
          <SheetHeader>
            <SheetTitle>
              Assigned Staff for Counter{" "}
              <span className="capitalize">{data?.id}</span>
            </SheetTitle>
            <SheetDescription>
              <Separator className=" h-[1px] font-thin rounded-full" />

              {/* <Form {...form}> */}
              <form
                // onSubmit={form.handleSubmit(onSubmit, onError)}
                className="flex flex-col py-4 gap-4"
                noValidate
              >
                <div className="flex flex-col justify-between items-center gap-2">
                  {staffs.length > 0 ? (
                    staffs?.map((item: any) => (
                      <div
                        key={item.id}
                        onClick={() => unassignStaff(item.id)}
                        className="cursor-pointer flex items-center justify-between w-full p-2 border border-transparent hover:border-primary rounded-md"
                        role="button"
                        tabIndex={0}
                        onKeyDown={(e) => {
                          if (e.key === "Enter" || e.key === " ") {
                            unassignStaff(item.id);
                          }
                        }}
                      >
                        <div className="flex items-center gap-2">
                          <Label
                            htmlFor="remove_cashier"
                            className="capitalize"
                          >
                            {item.first_name} {item.last_name}
                          </Label>
                        </div>
                        <i className="fa fa-xmark"></i>
                      </div>
                    ))
                  ) : (
                    <p>No Staff assigned</p>
                  )}
                </div>
              </form>
              {/* </Form> */}
            </SheetDescription>
          </SheetHeader>
        </SheetContent>
      </Sheet>
    </div>
  );
};

export default AssignCounter;
